import { useRef, useEffect } from "react";

export default function SingleUseSection() {
  const containerRef = useRef<HTMLDivElement>(null);

  const loadForm = () => {
    const script = document.createElement("script");
    script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.charset = "utf-8";

    script.onload = () => {
      if ((window as any).hbspt && containerRef.current) {
        (window as any).hbspt.forms.create({
          region: "eu1",
          portalId: "25229919",
          formId: "862b6254-909e-4712-8b5a-6b917a52129d",
          target: "#hubspotFormContainer",
          onFormReady: ($form: any) => {
            const buttonCtn = $form.querySelector(".actions");
            if (buttonCtn) {
              buttonCtn.style.display = "flex";
              buttonCtn.style.flexDirection = "row";
              buttonCtn.style.justifyContent = "center";
              buttonCtn.style.alignItems = "center";
            }
            const button = $form.querySelector(".hs-button");
            if (button) {
              button.style.backgroundColor = "rgb(0, 0, 0)";
              button.style.borderRadius = "24px";
              button.style.border = "none";
              button.style.fontSize = "16px";
              button.style.fontWeight = "600";
              button.style.padding = "16px 32px";
            }
            const textAll = $form.querySelectorAll(".hs-richtext");
            if (textAll) {
              textAll.forEach((el: HTMLElement) => {
                el.style.fontSize = "12px";
                el.style.lineHeight = "1.1em";
                el.style.color = "rgba(0,0,0,0.5)";
              });
            }

            const labelAll = $form.querySelectorAll("label");
            if (labelAll) {
              labelAll.forEach((el: HTMLElement) => {
                el.style.fontSize = "14px";
                el.style.color = "#555";
              });
            }

            const inputAll = $form.querySelectorAll(
              ".hs-input:not(input[type=checkbox])",
            );
            if (inputAll) {
              inputAll.forEach((el: HTMLElement) => {
                el.style.backgroundColor = "rgb(253, 250, 246)";
                el.style.height = "36px";
              });
            }
          },
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  };

  useEffect(() => {
    loadForm();
  }, []);

  return (
    <section id="pricing" className="bg-[#EFEBE5] py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div id="hubspotFormContainer" ref={containerRef} />
      </div>
    </section>
  );
}
